import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { SUBJECT_TYPE } from '../../common/constant'
import { TABLE_COL } from '../constant'
import { selectAlertById } from '../store/slice'
import { CheckboxCell } from './CheckboxCell'
import { DeleteCell } from './DeleteCell.js'
import { TriggerCell } from './TriggerCell'
import { TypeDescriptionCell } from './TypeDescriptionCell'

export const TableCell = ({ data, colId, rowId }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const isRead = useSelector(selectAlertById(rowId, 'readStatus'))

  const renderCell = () => {
    switch (colId) {
      case TABLE_COL.CHECKBOX:
        return <CheckboxCell rowId={rowId} />
      case TABLE_COL.SUBJECT_TYPE:
        return (
          <Translate
            value={
              Object.values(SUBJECT_TYPE).find(
                (item) => item.id === Number(data),
              )?.name || ' '
            }
          />
        )
      case TABLE_COL.TYPE_DESCRIPTION:
        return <TypeDescriptionCell rowId={rowId} />
      case TABLE_COL.DATE:
        return (
          <Element className="whiteSpaceNowrap">
            {formatDateTime(data, FORMAT.DATE, locale, timezone)}
          </Element>
        )
      case TABLE_COL.TRIGGER:
        return <TriggerCell rowId={rowId} data={data} />
      case TABLE_COL.DELETE:
        return <DeleteCell rowId={rowId} />
      default:
        return data
    }
  }

  return (
    <Element className={isRead ? 'fw400' : 'fw600'}>{renderCell()}</Element>
  )
}
